import { render, staticRenderFns } from "./ClienteProveedorForm.vue?vue&type=template&id=166169f7&"
import script from "./ClienteProveedorForm.vue?vue&type=script&lang=ts&"
export * from "./ClienteProveedorForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('166169f7', component.options)
    } else {
      api.reload('166169f7', component.options)
    }
    module.hot.accept("./ClienteProveedorForm.vue?vue&type=template&id=166169f7&", function () {
      api.rerender('166169f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ClienteProveedor/ClienteProveedorForm.vue"
export default component.exports